import {FC, ReactNode, useEffect, useState} from 'react'
import {useFetchCheckNeedEmployeeUpdate} from 'hooks/api/employees/checkNeedEmployeeUpdate'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {handleError} from 'libs/axiosErrorHandlers'

interface Props {
  children: ReactNode
  employeeId: string
  redirectPath: string
}

export const RequireEmployeeUpdateRouter: FC<Props> = ({children, employeeId, redirectPath}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const {isLoading, resource: checkNeedEmployeeUpdate, errors} = useFetchCheckNeedEmployeeUpdate(employeeId)
  const [isNotRequireUpdate, setIsNotRequireUpdate] = useState<boolean>(false)

  useEffect(() => {
    const getCheckNeedEmployeeUpdate = async () => {
      if (!isLoading) {
        if (errors) {
          await handleError(errors, dispatch)
          return
        }

        if (checkNeedEmployeeUpdate?.need) {
          history.push(redirectPath)
        } else {
          setIsNotRequireUpdate(true)
        }
      }
    }

    getCheckNeedEmployeeUpdate()
  }, [isLoading])

  return <>{!isLoading && isNotRequireUpdate && <>{children}</>}</>
}
